<template>
    <div class="formBox">
        <Header ref="height0" :hideIpt="true" />
        <van-form @submit="onSubmit" ref="inqForm">
            <!-- 公共字段 -->
            <van-field v-model="formData.name" maxlength="6" name="姓名" label="姓名" placeholder="请输入姓名"
                :rules="requiredRules('name', '姓名')">
                <template #label>
                    <div class="custom-label">姓名<span class="required-star">*</span> </div>
                </template>
            </van-field>
            <van-field maxlength="11" v-model="formData.phone" name="phone" label="联系电话" placeholder="请输入联系电话"
                :rules="[requiredRules('phone', '联系电话'), { validator: validatePhone, message: '请输入有效联系电话' }]">
                <template #label>
                    联系电话<span class="required-star">*</span>
                </template>
            </van-field>
            <van-field v-model="formData.code" maxlength="6" name="code" label="验证码" placeholder="请输入验证码"
                :rules="requiredRules('code', '验证码')">
                <template #button>
                    <van-button class="getCodeBtn" size="small" type="primary" native-type="button" @click.stop="postCode">
                        {{ timeKey ? `${countdown}s` : "获取验证码" }}
                    </van-button>
                </template>
                <template #label>
                    验证码<span class="required-star">*</span>
                </template>
            </van-field>
            <van-field v-model="formData.company" maxlength="26" name="company" label="公司" placeholder="请输入公司名称"
                :rules="requiredRules('company', '公司')">
                <template #label>
                    公司<span class="required-star">*</span>
                </template>
            </van-field>
            <van-field readonly clickable name="job_title" v-model="formData.job_title" label="职务" placeholder="点击选择职务"
                :rules="requiredRules('job_title', '职务')" @click="showPicker = true">
                <template #label>
                    职务<span class="required-star">*</span>
                </template>
            </van-field>
            <van-popup v-model="showPicker" position="bottom">
                <van-picker show-toolbar :columns="job_titleOptions" @confirm="setValue($event, 'job_title')"
                    @cancel="showPicker = false" />
            </van-popup>

            <van-field readonly clickable name="region" v-model="formData.region" :rules="requiredRules('region', '所在地区')"
                label="所在地区" placeholder="点击选择所在地区" @click="showregion = true">
                <template #label>
                    所在地区<span class="required-star">*</span>
                </template>
            </van-field>
            <van-popup v-model="showregion" position="bottom">
                <van-area :area-list="areaList" @confirm="setregion" @cancel="showregion = false" />
            </van-popup>
            <van-field readonly clickable name="industry" v-model="formData.industry" label="所在行业" placeholder="点击选择所在行业"
                :rules="requiredRules('industry', '所在行业')" @click="showIndustry = true">
                <template #label>
                    所在行业<span class="required-star">*</span>
                </template>
            </van-field>
            <van-popup v-model="showIndustry" position="bottom">
                <van-picker show-toolbar :columns="industryOptions" @confirm="setValue($event, 'industry')"
                    @cancel="showIndustry = false" />
            </van-popup>

            <!-- 动态插槽，供子组件传入额外字段 -->
            <slot :formData="formData" name="slotData"></slot>

            <!-- 提交按钮 -->
            <div style="margin: 23px 16px;">
                <van-button class="submitBtn" round block type="primary" native-type="submit" :disabled="!addInfoFlag">
                   {{this.formType == 'EditRegister' ? '保存' :'提交'}} 
                </van-button>
            </div>
        </van-form>
    </div>
</template>
  
<script>
import { Toast } from "vant";
import Header from "@/components/header";
import { areaList } from '@vant/area-data';
import Crypt from "@bluedot-tech/vue-ui/es/utils/crypt";
import config from "@/config/config";
export default {
    props: {
        formType: {
            type: String,
            required: true,
        },
    },
    components: {
        Header
    },
    data() {
        return {
            addInfoFlag:false,
            showPicker: false,
            showregion: false,
            showIndustry: false,
            isFormValid: false,
            areaList,
            timeKey: false,
            formData: {
                name: "",
                phone: "",
                code: "",
                company: "",
                job_title: "",
                region: "",
                industry: "",
                consult: "", // 联系我们特有字段
                remark: "",       // 联系我们特有字段
                category: "",     // 我要提问特有字段
                details: "",      // 我要提问特有字段
                path: [],       // 我要提问特有字段
            },
            countdown: 60,
            job_titleOptions: ["商务", "采购", "技术", "研发","生产","其他"],
            industryOptions: ["汽车", "电子", "工业", "医疗", "复合材料","标签","广告材料","卫生用品"],
        };
    },
    watch: {
        formData: {
            handler() {
                const requiredFields = this.getRequiredFields();
                this.isFormValid = requiredFields.every((field) => !!this.formData[field]);
                console.log('"requiredFields" ---:', this.isFormValid);
                this.addInfoFlag = true;
            },
            deep: true
        }

    },
    created() {
        this.checkUser().then(res => {
            if (!res.errcode) {
                let data = res;
                for (let key in data) {
                    if (this.formData.hasOwnProperty(key)) {
                        let crypt = new Crypt(config.crypto.publickey);
                        data.crypt_key = crypt.rsa_key_encrypt(); //加密公钥传参
                        data["phone"] = crypt.aes_encrypt(data["phone"]);

                        this.formData[key] = data[key];
                    }
                    if(data.phone_data){
                        this.formData['phone'] = data.phone_data;
                    }
                };
                this.$nextTick(()=>{
                    this.addInfoFlag = false;
                })
               
                console.log('this.formData ---:',this.formData);
                

            }
        })
    },
    methods: {
        checkUser() {
            return new Promise((resolve) => {
                let openid = this.$localStorage.getItem("openid");
                let params = { openid }
                this.$http.get("/api/platform/member/get-user-info", { params }).then((res) => {
                    resolve(res.data);
                })
            });
        },
        setValue(value, type) {
            console.log(' ---:', value, type);

            this.formData[type] = value;
            this.showPicker = false;
            this.showIndustry = false;
        },
        setregion(values) {
            this.formData.region = values
                .filter((item) => !!item)
                .map((item) => item.name)
                .join('/');
            this.showregion = false;
        },
        // 动态校验规则
        requiredRules(field, name) {
            return this.getRequiredFields().includes(field)
                ? [{ required: true, message: `请输入${name}` }]
                : [];
        },
        // 获取当前表单的必填字段
        getRequiredFields() {
            const requiredFields = {
                contactUs: [
                    "name",
                    "phone",
                    "code",
                    "company",
                    "job_title",
                    "region",
                    "industry",
                    "consult",
                    "remark",
                ],
                memberRegister: ["name", "phone", "code", "company", "job_title", "region", "industry"],
                EditRegister: ["name", "phone", "code", "company", "job_title", "region", "industry"],
                askQuestion: [
                    "name",
                    "phone",
                    "code",
                    "company",
                    "job_title",
                    "region",
                    "industry",
                    "category",
                    "details",
                    'path'
                ],
            };
            return requiredFields[this.formType] || [];
        },
        validatePhone(value) {
            return /^1[3-9]\d{9}$/.test(value);
        },

        postCode() {
            console.log('"!@3" ---:');
            if (this.timeKey == true) return; //阻止倒计时点击
            this.$refs.inqForm.validate("phone").then((res) => {
                this.timeKey = true; //关闭按钮

                var int = setInterval(() => {
                    this.countdown--;

                    if (this.countdown == 0) {
                        this.timeKey = false; //打开按钮

                        this.countdown = 60; //重置时间

                        return clearInterval(int); //清除计时器
                    }
                }, 1000);

                this.getCode();
            });
        },
        getCode() {
            let crypt = new Crypt(config.crypto.publickey);
            console.log("this.formData", this.formData);
            let data = {
                crypt_key: crypt.rsa_key_encrypt(), //加密公钥传参
                phone: crypt.aes_encrypt(this.formData["phone"]), //加密手机号
            };
            this.$http
                .post(`/api/platform/member/send-sms`, data)
                .then((res) => {
                    if (res.data.errcode) return;
                    Toast("发送成功,请注意查收");
                    // console.log(res, 'in this');
                })
                .catch((err) => { });
        },
   

        onSubmit() {
            if (!this.isFormValid) {
                this.$toast.fail("请填写完整表单");
                return
            }

            console.log("this.formData ---:", this.formData);
            Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: "提交中",
            });

            this.formData.name.replace(/^\s\s*/, "").replace(/\s\s*$/, ""); //姓名收尾去除空格
            let data = JSON.parse(JSON.stringify(this.formData)); //防止污染
            let crypt = new Crypt(config.crypto.publickey);
            data.crypt_key = crypt.rsa_key_encrypt(); //加密公钥传参
            data["phone"] = crypt.aes_encrypt(data["phone"]);
            data.openid = this.$localStorage.getItem("openid");
            let api = {
                memberRegister: '/api/platform/member/register',
                askQuestion: '/api/platform/member/question',
                contactUs: '/api/platform/member/about',
                EditRegister:`/api/platform/member/register/${data.openid}`,
            }
            let str = this.moniterTxt();

            this.$dataStatistics('click', `表单提交-${str}`);
            this.$http[this.formType == 'EditRegister' ? 'put' : 'post'](api[this.formType], data)
                .then(async (res) => {
                    console.log(res);
                    if (res.data.errcode) {
                        Toast.clear();
                        Toast(res.data.errmsg);
                        return;
                    }
                    
                    Toast.clear();
                    this.formKey = false;
                    this.$nextTick(() => {
                        this.$router.push(`/result?formType=${this.formType}`)
                    });
                })
                .catch((err) => { });
        },
        moniterTxt(){
            let str = "";
            if(this.formType == "memberRegister"){
                str = "会员注册"
            }else if(this.formType == "askQuestion"){
                str = "我要提问"
            }else if(this.formType == "contactUs"){
                str = "联系我们"
            }else if(this.formType == "EditRegister"){
                str = "修改信息"
            }
            return str
        },
    },
};
</script>
<style lang="less">
.required-star {
    color: #FF3141;
    font-size: 14px;
    font-weight: bold;
}
</style>
  
<style lang="less" scoped>
::v-deep .van-button--disabled {
    opacity: 1;
    background: #E5E5E5 !important;
}

::v-deep .van-field__label {
    width: 7.2em;
}

.submitBtn {
    border: none;
    background: #0059A3;
    border-radius: 4px;
    font-weight: bold;
    letter-spacing: 1px;
    font-size: 16px;
    color: #FFFFFF;
}

/deep/.van-cell {
    display: block !important;
}

.custom-label {
    font-size: 14px;
    color: #333333;
}

/deep/.van-cell__title {
    margin-bottom: 4px;

}

/deep/.van-field__control::placeholder {
    font-size: 14px;
    color: #9F9F9F;
}

.getCodeBtn {
    background: #0059A3;
    border-radius: 4px 4px 4px 4px;
    border: none;
}
</style>